import React, {Component} from 'react';
import styles from './header.css';

export default class Header extends Component {

    componentDidMount(){
        if(localStorage.getItem('authlogin')==='false'){
            window.location.href = "#/login";
        }
        /*else{
            window.location.href = "#/dashboard";
        }
        setTimeout(() => {
            window.location.href = "#/dashboard";
        }, 300);
        if(localStorage.getItem('dashrefres')!=='true'){
            //setTimeout(() => {
                //alert(localStorage.getItem('dashrefres'));
                localStorage.setItem('dashrefres','true');
                window.location.href = "#/dashboard";
            //}, 500);
        }else if(localStorage.getItem('dashrefres')==='true'){
            localStorage.setItem('dashrefres','');
        }*/
    }

    render(){
        return (
            <header className="main-header">
            </header>
            )
    }
}